import './bootstrap';
import '../css/app.css';
import '../css/tooltip.css';

import { createApp, h } from 'vue';
import { createInertiaApp } from '@inertiajs/vue3';
import { dataDogRumSetup } from '@/Common/DataDogRumSetup.js';
import { ZiggyVue } from '../../vendor/tightenco/ziggy/dist/vue.m';
import { sentrySetup } from '@/Common/SentrySetup.js';
import { tooltipSetup } from '@/Components/Tooltip.js';
import { redirectLegacyUrl } from '@/legacy-redirects.js';
import PosthogPlugin from '@/Plugins/posthog.js';
import i18n from '@/Plugins/i18n.js';

const urlSearchParams = new URLSearchParams(window.location.search);
const layout = urlSearchParams.has('layout')
  ? urlSearchParams.get('layout')
  : 'web';

!redirectLegacyUrl() &&
  void createInertiaApp({
    resolve: (name) => {
      const pages = import.meta.glob('./Pages/**/*.vue', { eager: true });
      return pages[`./Pages/${name}.vue`];
    },
    setup({ el, App, props, plugin }) {
      /** @type {import('../../vendor/tightenco/ziggy').Config} */
      let ziggyConfig = null;
      if (props.initialPage.props.ziggy) {
        ziggyConfig = {
          ...props.initialPage.props.ziggy,
          location: new URL(props.initialPage.props.ziggy.location),
          url: props.initialPage.props.ziggy.location
        };
      }

      // Set up i18n with Laravel locale
      const locale = props.initialPage.props.locale || 'en';

      // Set the current locale (translations are already loaded at compile time)
      i18n.global.locale.value = locale;

      const app = createApp({ render: () => h(App, props) })
        .use(plugin)
        .use(ZiggyVue, ziggyConfig)
        .use(i18n)
        .use(PosthogPlugin);

      app.provide('layout', layout);
      tooltipSetup(app);
      sentrySetup(app);
      dataDogRumSetup();

      return app.mount(el);
    },
    progress: {
      color: 'var(--color-primary-500)',
      showSpinner: true
    }
  });
